export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/village/query`,
          data
        });
      },

      queryPage(data){
          return http.json({
              url: `/village/queryPage`,
              data
          });
      },
      list(data){
          return http.json({
              url: `/village/list`,
              data
          });
      },
      queryAll(data){
          return http.json({
              url: `/village/queryAll`,
              data
          });
      },


  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/community.js